<template>
  <div
    id="contents"
    :class="{ contents: true, no_contents: !existCharacterList }"
  >
    <div class="sticky_header">
      <div class="selected_character">
        <span class="character_setting_game">
          <span>
            {{ gameName }}
          </span>
          <span v-if="existSelectedCharacter" class="check_wrapper">
            설정중
            <img class="check_img" src="../../assets/images/ico_check.png" />
          </span>
        </span>
        <span v-if="existCharacterList" class="line"></span>
        <span v-if="existSelectedCharacter" class="character_info">
          <span class="character_name">
            {{ selectedCharacter.gcName }}
          </span>
          <span class="character_server">
            <span>{{ selectedCharacter.worldName }}</span>
            <span>
              <span class="bar"></span>
              <span>Lv.{{ selectedCharacter.gcLevel }}</span>
            </span>
            <span>
              <span class="bar"></span>
              <span>{{ selectedCharacter.gcClass }}</span>
            </span>
          </span>
        </span>
        <span v-else-if="existCharacterList" class="character_info_none">
          <img src="../../assets/images/alert.png" class="alert_icon" />
          <p>상품을 수령할 캐릭터를 선택해주세요.</p>
        </span>
      </div>
      <div v-if="existCharacterList" class="character_filter">
        <span
          :class="{ filter_name: true, on: sortType === 0 }"
          @click="handleFilter(0)"
        >
          이름순
        </span>
        <span class="bar"></span>
        <span
          :class="{ filter_level: true, on: sortType === 1 }"
          @click="handleFilter(1)"
        >
          레벨순
        </span>
        <span class="bar"></span>
        <span
          :class="{ filter_created_date: true, on: sortType === 2 }"
          @click="handleFilter(2)"
        >
          생성순
        </span>
      </div>
    </div>
    <div v-if="existCharacterList" class="character_setting_wrapper">
      <ul class="character_list">
        <CharacterItem
          v-for="(character, idx) in this.characterList"
          :key="idx"
          :character="character"
          :isSelectedCharacter="selectedCharacter.gcid === character.gcid"
          @selectCharacter="handleSelectCharacter"
        />
      </ul>
      <CharacterListPagination
        :pageNo="this.pageNo"
        :totalPageCount="this.totalPageCount"
        @changePage="handleChangePage"
      />
    </div>
    <contents-none
      v-if="!existCharacterList"
      none-text="보유하신 캐릭터가 없습니다."
    ></contents-none>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import { isLogin, beforeSendLog } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CharacterItem from './CharacterItem.vue'
import ContentsNone from '@/views/base/ContentsNone'
import CharacterListPagination from './CharacterListPagination.vue'

export default {
  name: 'CharacterSetting',
  components: {
    CharacterItem,
    ContentsNone,
    CharacterListPagination
  },
  data() {
    return {
      isLogin: isLogin()
    }
  },
  computed: {
    ...mapGetters('main', ['name', 'gameName', 'shopId']),
    ...mapGetters('character', [
      'characterList',
      'selectedCharacter',
      'totalPageCount',
      'pageNo',
      'pageSize',
      'sortType'
    ]),
    isNameFilter() {
      return this.sortType === 0
    },
    existSelectedCharacter() {
      return !Object.values(this.selectedCharacter).every(
        value => value === null || value === 0
      )
    },
    existCharacterList() {
      return this.characterList.length > 0
    }
  },
  methods: {
    ...mapActions('my', ['getUserData']),
    ...mapActions('character', [
      'getCharacterList',
      'getSelectedCharacter',
      'setCharacter',
      'updateCharacter',
      'updateSortType'
    ]),
    //type = 0: name, 1: level, 2: createdDate
    handleFilter(sortType) {
      window.scrollTo(0, 0)
      let filterForA2Slog = ''

      if (sortType === 0) {
        // name
        filterForA2Slog = 'FilterName'
      } else if (sortType === 1) {
        // level
        filterForA2Slog = 'FilterLevel'
      } else if (sortType === 2) {
        // createdDate
        filterForA2Slog = 'FilterCreatedDate'
      }

      beforeSendLog(filterForA2Slog, { ShopID: this.shopId })

      this.updateSortType(sortType)
      this.getCharacterList({
        pageNo: 1,
        pageSize: this.pageSize,
        sortType
      })
    },
    async handleSelectCharacter(character) {
      if (character) {
        beforeSendLog('Select', {
          CharacterName: character.gcName,
          CharacterServer: character.worldName,
          CharacterLevel: character.gcLevel,
          ShopID: this.shopId
        })
      }

      if (this.existSelectedCharacter) {
        this.updateCharacter(character)
      } else {
        this.setCharacter(character)
      }

      this.getCharacterList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        sortType: this.sortType
      })
    },
    handleChangePage(pageNo) {
      window.scrollTo(0, 0)
      this.getCharacterList({
        pageNo,
        pageSize: this.pageSize,
        sortType: this.sortType
      })
    }
  },
  created() {
    this.getCharacterList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      sortType: this.sortType
    })
    this.getSelectedCharacter()
  },
  mounted() {
    EventBus.$on('logout', () => {
      this.isLogin = false
    })
  }
}
</script>

<style lang="scss" scoped>
.sticky_header {
  position: sticky;
  top: 55px;
}
.selected_character {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #6134f1;
  padding: 15px 20px;
  color: #fff;
  .line {
    width: 100%;
    height: 1px;
    background-color: #ededed;
    opacity: 0.2;
    margin: 10px 0;
  }
  .character_setting_game {
    display: flex;
    justify-content: space-between;
    font-family: 'Noto Sans KR';
    font-size: 13px;
    .check_wrapper {
      display: flex;
    }
    .check_img {
      background-color: transparent;
      margin-left: 2px;
    }
  }
  .character_info {
    display: flex;
    flex-direction: column;
    align-self: center;
    text-align: center;
    font-family: 'Noto Sans KR';
    .character_name {
      font-size: 15px;
      font-weight: bold;
    }
    .character_server {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 9px;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.8);
    }
    .bar {
      display: inline-block;
      width: 1px;
      height: 12px;
      margin: 0px 6px;
      background-color: #a5a5ac;
      opacity: 0.2;
    }
  }
  .character_info_none {
    display: flex;
    align-self: center;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    font-family: 'Noto Sans KR';
    margin: 10px 0;
  }
}
.character_filter {
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  color: #636376;
  padding: 14px 17px 12px 0;
  font-family: 'Noto Sans KR';
  background-color: #f7f7f7;
  .filter_name {
    align-self: center;
    cursor: pointer;
  }
  .filter_level {
    align-self: center;
    cursor: pointer;
  }
  .filter_created_date {
    align-self: center;
    cursor: pointer;
  }
  .on {
    color: #6134f1;
  }
  .bar {
    width: 1px;
    height: 12px;
    margin: 4px 6px 3px;
    background-color: #a5a5ac;
  }
}

.character_setting_wrapper {
  // padding: 16px;
  .character_list {
    margin-top: 10px;
  }
}

.alert_icon {
  width: 16px;
  height: 16px;
  background-color: transparent;
  margin-right: 6px;
}
.contentsNone {
  top: 98px;
}
.no_contents {
  min-height: auto;
}
</style>
